var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDefault(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 84,
    height: 84,
    viewBox: "0 0 84 84",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 84,
    height: 84,
    rx: 42,
    fill: "#EBEBEB"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5285_71849)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 56L56 56",
    stroke: "#C2C2C2",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0014 56C27.9491 52.3388 29.3944 48.8073 32.0194 46.182C34.6445 43.5567 38.2345 42.0524 42 42C45.7655 42.0524 49.3555 43.5567 51.9806 46.182C54.6056 48.8073 56.0509 52.3388 55.9986 56",
    stroke: "#C2C2C2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42 42C45.866 42 49 38.866 49 35C49 31.134 45.866 28 42 28C38.134 28 35 31.134 35 35C35 38.866 38.134 42 42 42Z",
    stroke: "#C2C2C2",
    strokeWidth: 2.5,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5285_71849"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(26 26)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefault);
export default __webpack_public_path__ + "static/media/Default.d4ce438dd61ca67d78a62a24b5b2892b.svg";
export { ForwardRef as ReactComponent };